'use client';

import { AnimatePresence, m, useReducedMotion } from 'framer-motion';
import { useLanguage } from '@/context/LanguageContext';
import { useConsent } from '@/context/ConsentContext';
import { Button } from '@/components/ui/button';
import { ACCEPT_ALL, NECESSARY_ONLY } from '@/lib/consent';
import CookiePreferencesModal from '@/components/CookiePreferencesModal';

export default function CookieConsentBanner() {
    const { isRTL, t } = useLanguage();
    const { status, preferencesOpen, decide, openPreferences } = useConsent();
    const reduceMotion = useReducedMotion();

    const duration = reduceMotion ? 0 : 0.35;

    return (
        <>
            <AnimatePresence>
                {status === 'pending' && !preferencesOpen && (
                    <m.div
                        key="cookie-banner"
                        dir={isRTL ? 'rtl' : 'ltr'}
                        initial={{ y: reduceMotion ? 0 : 80, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: reduceMotion ? 0 : 80, opacity: 0 }}
                        transition={{ duration, ease: 'easeOut' }}
                        className="fixed inset-x-0 bottom-0 z-[9998] p-3 sm:p-5"
                        role="region"
                        aria-label={t('cookie.banner.aria')}
                    >
                        <div className="mx-auto max-w-3xl rounded-2xl border border-border bg-card/95 p-5 shadow-xl ring-1 ring-primary/10 backdrop-blur-md">
                            <h2 className="text-base font-bold text-foreground">{t('cookie.banner.title')}</h2>
                            <p className="mt-1 text-sm text-muted-foreground">{t('cookie.banner.body')}</p>
                            <button
                                type="button"
                                onClick={openPreferences}
                                className="mt-2 text-xs font-medium text-primary underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded"
                            >
                                {t('cookie.banner.customize')}
                            </button>
                            <div className={`mt-4 flex flex-col gap-3 sm:flex-row ${isRTL ? 'sm:flex-row-reverse' : ''}`}>
                                <Button variant="glow" onClick={() => decide(ACCEPT_ALL)}>
                                    {t('cookie.banner.acceptAll')}
                                </Button>
                                <Button variant="outline" onClick={() => decide(NECESSARY_ONLY)}>
                                    {t('cookie.banner.necessaryOnly')}
                                </Button>
                            </div>
                        </div>
                    </m.div>
                )}
            </AnimatePresence>

            <AnimatePresence>
                {preferencesOpen && <CookiePreferencesModal key="cookie-prefs" />}
            </AnimatePresence>
        </>
    );
}
